import React from "react";
import "./User.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";

class User extends React.Component {
  state = {
    userData:{
    },
    event:[
      {
        685107469184:[
        ]
      }
    ]
  };
  async componentDidMount() {
    let token=localStorage.getItem('AccessToken');
    if(token){
   this.getData();

    }else{
      this.props.history.push('/login')

  }
  }
  getData=async()=>{
    this.setState({loading:true});
    try{
      //获取用户数据
      let res = await http().getTable({
        resid:685988118358,
      });
      let res2 = await http().getRecordAndSubTables({
        resid:685123321857,
        subresid:685107469184,
        getsubresource: 1
      });
      if(res.data.data.length>0){
        this.setState({userData:res.data.data[0]});
      }else{
        Toast.fail('未找到用户，请重新登陆')
        this.history.props.push('/login')
      }
      let obj =res2.data.data[0];
      let arr = obj[685107469184];
      let n = 0;
      while(n<arr.length){
        let v='';
        let res3 = await http().getTable({
          resid:arr[n].sourceTable
        })
        if(res3.data.data.length>0){
          v=res3.data.data[0][arr[n].sourceField];
        }
        arr[n].value=v;
        n++;
      }
      this.setState({
        event:res2.data.data,
        loading:false
      })
    }catch(e){
      console.error(e);
      if(e.message=='loginerror'){
        this.props.history.push('/login');
      }
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }

  render() {
    return (
      <div className="User">
        {this.state.loading?<Loading/>:null}
       <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
         <div className='avatar'  onClick={()=>{
                    this.props.history.push('/user');
                  }}
                  style={this.state.userData.imgUrl?{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'contain'}:{}}
                  
                  ></div>
        </div>
        <div className='container'>
                  <div className='userInfo'>
                    <div className='avatar'
                    style={{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundColor:'#fff',backgroundRepeat:'no-repeat',backgroundSize:'contain',backgroundPosition:'center'}}
                    >
                    </div>
                    <div className='msg'>
                      <div>
                        <b>姓名：</b>{this.state.userData.memberName}
                      </div>
                      <div className='modi' onClick={()=>{this.props.history.push('/register?edit=1')}}>
                        <i></i>修改信息
                      </div>
                      <div style={{width:'100%'}}>
                        <b>用户类型：</b>{this.state.userData.chara}
                      </div>
                      <div></div>
                      <div>
                        <b>病种：</b>{this.state.userData.illness}
                      </div><div>
                        <b>医生：</b>{this.state.userData.doctorName}
                      </div>
                    </div>
                  </div>
                  <div className='events'>
                    <ul>
                      {
                        this.state.event.map(
                          (item,key)=>{
                            return(
                              <li>
                                <h3 
                                  onClick={
                                    ()=>{
                                      this.props.history.push(item.eventRoute)
                                    }
                                  }
                                ><i
                                style={{
                                  backgroundImage:'url('+item.logoUrl+')',
                                  backgroundPosition:'center',
                                  backgroundSize:'contain',
                                  backgroundRepeat:'no-repeat'

                                }}
                                ></i>{item.eventName}</h3>
                                {
                                  item[685107469184].map(
                                    (item2,index2)=>{
                                      return(
                                        <div className='ctr' index={'_'+index2}>
                                        <div>{item2.parameterName}：{item2.value}</div>
                                        <div className='routes'>
                                        <div className={item2.action1?'':'hidden'}>
                                            <span onClick={()=>{this.props.history.push(item2.action1Route+'?eventId='+item2.eventId);}}>{item2.action1}</span>
                                        </div>
                                        <div className={item2.action2?'':'hidden'}>
                                            <span onClick={()=>{this.props.history.push(item2.action2Route+'?eventId='+item2.eventId);}}>{item2.action2}</span>
                                        </div>
                                        <div className={item2.action3?'':'hidden'}>
                                            <span onClick={()=>{this.props.history.push(item2.action3Route+'?eventId='+item2.eventId);}}>{item2.action3}</span>
                                        </div>
                                        </div>
                                        </div>
                                      )
                                    }
                                  )
                                }
                              </li>
                            )
                          }
                        )
                      }
                    </ul>
                  </div>
                  <div className='underBtn'>
                    <div onClick={()=>{
                      window.localStorage.clear();
                      this.props.history.push('/login');
                      }}>
                      退出登录
                    </div>
                  </div>
        </div>
      </div>
    );
  }
}

export default User;
